// M26.5 — single source of truth for department identity color, keyed by
// the same role keys already used throughout workforce/* and
// Nexceo::Ai::WorkforceRegistry::ROLES (company_coordinator, sales_manager,
// project, crm, documentation, calendar, marketing, finance, legal,
// support, nexa). Colors are the exact ones specified for this milestone —
// not a restyle of the M26.2 palette.
export const DEPARTMENT_COLORS = {
  company_coordinator: {
    label: 'Company',
    hex: '#8b5cf6',
    bgClass: 'bg-purple-50 dark:bg-purple-500/10',
    textClass: 'text-purple-600 dark:text-purple-400',
    borderClass: 'border-purple-300 dark:border-purple-500/40',
  },
  sales_manager: {
    label: 'Sales',
    hex: '#f97316',
    bgClass: 'bg-orange-50 dark:bg-orange-500/10',
    textClass: 'text-orange-600 dark:text-orange-400',
    borderClass: 'border-orange-300 dark:border-orange-500/40',
  },
  project: {
    label: 'Project',
    hex: '#3b82f6',
    bgClass: 'bg-blue-50 dark:bg-blue-500/10',
    textClass: 'text-blue-600 dark:text-blue-400',
    borderClass: 'border-blue-300 dark:border-blue-500/40',
  },
  crm: {
    label: 'CRM',
    hex: '#6366f1',
    bgClass: 'bg-indigo-50 dark:bg-indigo-500/10',
    textClass: 'text-indigo-600 dark:text-indigo-400',
    borderClass: 'border-indigo-300 dark:border-indigo-500/40',
  },
  documentation: {
    label: 'Documentation',
    hex: '#14b8a6',
    bgClass: 'bg-teal-50 dark:bg-teal-500/10',
    textClass: 'text-teal-600 dark:text-teal-400',
    borderClass: 'border-teal-300 dark:border-teal-500/40',
  },
  calendar: {
    label: 'Calendar',
    hex: '#22c55e',
    bgClass: 'bg-green-50 dark:bg-green-500/10',
    textClass: 'text-green-600 dark:text-green-400',
    borderClass: 'border-green-300 dark:border-green-500/40',
  },
  marketing: {
    label: 'Marketing',
    hex: '#ec4899',
    bgClass: 'bg-pink-50 dark:bg-pink-500/10',
    textClass: 'text-pink-600 dark:text-pink-400',
    borderClass: 'border-pink-300 dark:border-pink-500/40',
  },
  finance: {
    label: 'Finance',
    hex: '#10b981',
    bgClass: 'bg-emerald-50 dark:bg-emerald-500/10',
    textClass: 'text-emerald-600 dark:text-emerald-400',
    borderClass: 'border-emerald-300 dark:border-emerald-500/40',
  },
  legal: {
    label: 'Legal',
    hex: '#eab308',
    bgClass: 'bg-yellow-50 dark:bg-yellow-500/10',
    textClass: 'text-yellow-700 dark:text-yellow-400',
    borderClass: 'border-yellow-300 dark:border-yellow-500/40',
  },
  support: {
    label: 'Support',
    hex: '#6b7280',
    bgClass: 'bg-gray-50 dark:bg-gray-500/10',
    textClass: 'text-gray-600 dark:text-gray-400',
    borderClass: 'border-gray-300 dark:border-gray-500/40',
  },
  nexa: {
    label: 'NEXA',
    hex: '#06b6d4',
    bgClass: 'bg-cyan-50 dark:bg-cyan-500/10',
    textClass: 'text-cyan-600 dark:text-cyan-400',
    borderClass: 'border-cyan-300 dark:border-cyan-500/40',
  },
};

const FALLBACK = DEPARTMENT_COLORS.support;

export function departmentColor(roleKey) {
  return DEPARTMENT_COLORS[roleKey] || FALLBACK;
}
